import PropTypes from 'prop-types';
import { useI18n } from '../../../../../context/I18nContext';
import './MessageStatusIndicator.css';

const MessageStatusIndicator = ({
  read = false,
  onClick = null,
}) => {
  const { t } = useI18n();

  const handleClick = (e) => {
    if (onClick) {
      e.stopPropagation();
      onClick();
    }
  };

  return (
    <span
      className="message-status-indicator"
      title={(read) ? t('MessageReadStatus.read') : t('MessageReadStatus.sent')}
      onClick={handleClick}
      style={{ cursor: onClick ? 'pointer' : 'default' }}
    >
      {
        (read) ? <i className="fa fa-check-circle read" /> : <i className="fa fa-check" />
      }
    </span>
  );
};

MessageStatusIndicator.propTypes = {
  read: PropTypes.bool,
  onClick: PropTypes.func,
};

export default MessageStatusIndicator;
